<!-- TODO: Replace this html with the aproved table icon when that is finalized -->
<div class="tile-type-mat-icon-wrapper">
   <mat-icon>table_chart</mat-icon>
</div>
